
import React from 'react';
import {Action, DashboardContainer, TextLoading} from "../../funcs/utils";
import { PurchaseTable } from "./purchase-table";
import {SegregatedPaymentsTable} from "./segregated-payments-table";
import { save_csv_blob } from "./csv-util";

class SASecurityPurchase extends React.Component {

  constructor() {
    super();
    this.state = {
      doing_cancel: false,
      doing_csv: false,
    };
  }

  componentDidMount() {
    if (this.is_empty()) {
      this.load_items();
    }
  }

  is_empty = () => {
    const purchases = this.props.securityPurchase;
    return purchases.open.length === 0
      && purchases.payments.length === 0
      && purchases.settled.length === 0;
  }

  load_items = () => {
    this.props.loadSecurityAdminItems();
  }

  renderTable = queue_items => {
    return null;
  }

  renderCSV = (do_lastname_firm) => {
    const on_click = () => {
      this.setState({ doing_csv: true});
      const items = this.props.securityPurchase.open.concat(
        this.props.securityPurchase.settled);
      save_csv_blob(items, do_lastname_firm);
      this.setState( { doing_csv: false });
    }
    return (
      <div style={{display: "flex", justifyContent: "center"}}>
        <Action onClick={on_click}>
          <TextLoading label={"Download CSV"} loading={this.state.doing_csv}/>
        </Action>
      </div>
    )
  }

  render = () => {

    const client = this.props.client;
    const securities = this.props.securityPurchase;
    const wlf = this.props.app.wlf;
    const no_payments = wlf.ui && wlf.ui.wlf_admin && wlf.ui.wlf_admin.no_payments;
    const do_lastname_firm = wlf.ui && wlf.ui.wlf_admin && wlf.ui.wlf_admin.ticket_lastname_firm;
    const container_style = {
      paddingTop: "0",
    }
    return (
      <div className={"img-col"} style={container_style}>
        { this.renderCSV(do_lastname_firm)}
        <DashboardContainer
          client={client}
          title={"Pending Trades"}
          spinner={securities.loading}>
          <PurchaseTable
            actions={true}
            do_lastname_firm={do_lastname_firm}
            items={securities.open}
            component={this}/>
        </DashboardContainer>
        { !no_payments && <DashboardContainer
          client={client}
          title={"Payments To Segregated Account"}
          spinner={securities.loading}>
          <SegregatedPaymentsTable
            items={securities.payments}
            component={this}/>
        </DashboardContainer> }
        <DashboardContainer
          client={client}
          title={"Settled Trades"}
          spinner={securities.loading}>
          <PurchaseTable
            do_lastname_firm={do_lastname_firm}
            closed_time={true}
            items={securities.settled}
            component={this}/>
        </DashboardContainer>
      </div>
    )
  }
}

export { SASecurityPurchase };
